import React from 'react'
import styled from 'styled-components'
import { Grid, Col, Row } from 'react-styled-flexboxgrid'

const Container = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  color: ${props => props.theme.colors.text.header};
  width: 100%;
`

const ListItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`

const ListIcon = styled.div`
  font-size: 1.8rem;
  color: ${props => props.theme.colors.text.label};
  margin-bottom: 5px;
`

const ListHeader = styled.div`
  font-family: ${props => props.theme.fonts.avenirNextDemi};
  color: ${props => props.theme.colors.text.label};
`

const ListContent = styled.div`
  color: ${props => props.theme.colors.text.label};
`

const COL_SIZE = {
  lg: 6,
  md: 6,
  sm: 6,
  xs: 12
}

const List = ({ items }) => {
  return (
    <Container>
      <Grid style={{ width: '100%' }}>
        <Row>
          {items.map(item => (
            <Col key={item.title} {...COL_SIZE}>
              <ListItem>
                {item.icon ? <ListIcon>{item.icon}</ListIcon> : null}
                <ListHeader>{item.title}</ListHeader>
                {item.content ? (
                  <ListContent>{item.content}</ListContent>
                ) : null}
              </ListItem>
            </Col>
          ))}
        </Row>
      </Grid>
    </Container>
  )
}

export default List
